/**
 * Social Share JS.
 *
 * @type {Object}
 */
const SocialShare = {

	socialLink: '.social-post-share-link',

	/**
	 * Initialize.
	 *
	 * @return {void}
	 */
	init() {
		if ( null !== document.querySelector( this.socialLink ) ) {
			document.querySelectorAll( this.socialLink ).forEach( ( link ) => {
				link.addEventListener( 'click', ( event ) => this.openSharer( event ) );
			} );
		}
	},

	/**
	 * Open Sharer Window.
	 *
	 * @param {Object} event The click event object.
	 *
	 * @return {void}
	 */
	openSharer( event ) {
		event.preventDefault();
		event.stopPropagation();

		const anchor = event.target.closest( 'a' );

		const features = {
			width: 720,
			height: 570,
			toolbar: 0,
			resizable: 1,
			scrollbars: 1,
			status: 1,
		};

		features.left = ( screen.width - features.width ) / 2;
		features.top = ( screen.height - features.height ) / 2;

		const windowFeatures = Object.entries( features ).map(
			( [ key, value ] ) => `${ key }=${ value }`
		).join( ',' );

		const handle = window.open(
			anchor.getAttribute( 'href' ),
			'_blank',
			windowFeatures
		);

		if ( ! handle ) {
			document.location.href = anchor.getAttribute( 'href' );
		}
	},
};

export default SocialShare;
